<template>  
  <div class="gantt-container mt-0">
    <b-table-simple small bordered responsive>
      <b-thead>
        <b-tr>
          <b-th 
            sticky-column
            class="gantt-left-column text-secondary"
          >Поставка</b-th>
          <b-th
            v-for="day in periodOfDates"
            :key="$moment(day).valueOf()"
            class="gantt-column text-secondary"
          >
          {{ $moment(day).format('DD.MM.YYYY') }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="(active, o_index, index) in activities"
          :key="o_index"
        >
          <b-th class="gantt-left-column" sticky-column>
            <p 
              @click="openOrderSidebar(o_index, '', {tab: '23'})"
              class="mb-1 mt-2 font-weight-bold cursor-pointer" 
              :title="`${active.length} изменений(ия)`"
            >#{{ o_index }} / <span v-html="getCompanyFromActivity(active)"></span></p>
    
            <!-- <div class="gantt-group mb-2">
              <div
                v-for="act in active"
                :key="act.id"
                class="gantt-element"
              >
                {{ act.property_name }}: {{ act.property_value }}
              </div>
            </div> -->
          </b-th>
          <b-td
            v-for="day in periodOfDates"
            :key="$moment(day).valueOf()"
          >
            <template v-if="$moment(day).format('DD.MM.YYYY') === firstDayOfActivities(o_index)">
              <div 
                class="gantt-graph-bar cursor-pointer"
                :style="`background-color: ${colors[index]};`"
                title="кликните, чтобы открыть подробности"
                @click="openActivitiesToast(active)"
              >
                <div class="gantt-graph-text">
                  Изменений: {{ activitiesLength(active) }}
                </div>
              </div>
            </template> 
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-th variant="secondary" class="gantt-left-column" sticky-column>
            <div class="text-right font-weight-normal">
              Всего изменений: <span class="font-weight-bold">{{ summaryCountOfChanges }}</span>
            </div>
          </b-th>
          <b-td :colspan="periodOfDates.length ? periodOfDates.length : 1" variant="secondary"></b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
    <b-toast 
      v-if="isMoreAboutActivity"
      id="more-about-activity" 
      title="Изменения" 
      no-auto-hide
      @hidden="isMoreAboutActivity = false"
    >
      <div style="max-height: 600px; overflow-y: auto; overflow-x: hidden;">
        <div 
          class="gantt-left-column"
          v-for="(active, t_index, index) in moreAboutActivity"
          :key="t_index"
        >
          <p class="mb-1 mt-2 font-weight-bold" :title="`${active.length} изменений(ия)`">{{ t_index }}</p>
          <div class="gantt-group mb-2">
            <div
              v-for="act in active"
              :key="act.id"
              class="gantt-element"
            >
              {{ act.property_name }}: {{ act.property_value }}
            </div>
          </div>
        </div>
      </div>
    </b-toast>
  </div>
</template>

<script>
import colorArray from '@/constants/colorArray';
import { openOrderSidebar } from '@/mixins/openOrderSidebar';

export default {
  props: {
    activities: {
      type: Object,
      default: () => [],
    }
  },
  mixins: [
    openOrderSidebar
  ],
  data() {
    return {
      colors: colorArray,
      periodOfDates: [],
      summaryCountOfChanges: 0,
      moreAboutActivity: null,
      isMoreAboutActivity: false
    }
  },
  mounted() {
    this.getPeriodOfDates();
    this.getSummaryCountOfChanges();
  },  
  methods: {
    getPeriodOfDates() {
      let allDatesInRaw = [];

      // Collecting dates
      for (let o_key in this.activities) {
        for (let a_key in this.activities[o_key]) {
          allDatesInRaw.push(a_key);
        }
      }

      // Parse dates with the specific format, sort and remove duplicates
      allDatesInRaw = allDatesInRaw
        .map(dateStr => this.$moment(dateStr, 'DD.MM.YYYY HH:mm'))
        .sort((a, b) => a.diff(b))
        .filter((date, index, self) => 
          index === 0 || !date.isSame(self[index - 1], 'day')
        );

      if (allDatesInRaw.length > 0) {
        // Identify start and end dates
        const start = allDatesInRaw[0];
        const end = allDatesInRaw[allDatesInRaw.length - 1];

        let dates = [];

        // Iterate day by day
        for (let m = this.$moment(start); m.isBefore(end); m.add(1, 'day')) {
          dates.push(this.$moment(m));
        }
        dates.push(this.$moment(end)); // Include the last day

        this.periodOfDates = dates;
      } else {
        this.periodOfDates = [];
      }
    },
    firstDayOfActivities(o_index) {
      return this.$moment(Object.keys(this.activities[o_index])[0], ['DD.MM.YYYY', 'MM.DD.YYYY']).format('DD.MM.YYYY');
    },
    activitiesLength(active) {
      let len = 0;
      for (let key in active) {
        len += active[key].length;
      }

      return len;
    },
    getSummaryCountOfChanges() {
      for (let o_key in this.activities) {
        for (let a_key in this.activities[o_key]) {
          this.summaryCountOfChanges += this.activities[o_key][a_key].length;
        }
      }
    },
    getCompanyFromActivity(active) {
      let company = 'Компания не указана';

      for (let key in active) {
        
        if (active[key][0] && active[key][0].company) {
          let actCompany = active[key][0].company;
          company = `<span title="${actCompany.inn}">${actCompany.name}</span>`;
        }

        break;
      }

      return company;
    },
    openActivitiesToast(activity) {
      this.isMoreAboutActivity = true;
      this.moreAboutActivity = activity;

      this.$nextTick(() => {
        this.$bvToast.show('more-about-activity');
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~/components/ui/kanban/gantt.scss';
</style>